import { render, staticRenderFns } from "./App.vue?vue&type=template&id=036148ce"
import script from "./ctrl.js?vue&type=script&lang=js&external"
export * from "./ctrl.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports